import { api } from "../api";

export const bookingService = {
  getBooking,
  getBookingSummary,
  getBookingWithSummary,
  updatePassengers,
  getAncillaries,
  getSeatMap,
  addBaggage,
  removeBaggage,
  addInsurance,
  removeInsurance,
  addLounge,
  removeLounge,
  addHotel,
  removeHotel,
  addExpressBag,
  removeExpressBag,
  addPriorityCheckin,
  removePriorityCheckin,
  addCarryOnBags,
  removeCarryOnBags,
  addOversizedItems,
  removeOversizedItems,
  addCounterCheckin,
  removeCounterCheckin,
  addOnlineCheckin,
  removeOnlineCheckin,
  addWhatsApp,
  removeWhatsApp,
  assignSeat,
  clearSeat,
  clearAllSeat,
  changeMeals,
  populateBooking,
  resetSegment,
  summaryPnr,
  printItinerary,
  printItineraryWithoutPrice,
  getPKPassFile,
  feedback,
  ratePostDeparture,
}

function getBooking(showAll) {
  const data = showAll ? { showAll } : undefined;
  return api.getFetch(`api/booking`, data)
}


function getBookingSummary() {
  return api.getFetch(`api/booking/summary`)
}

function getBookingWithSummary() {
  return api.getFetch(`api/booking/BookingSummary`)
}

function updatePassengers(passengers, contact) {
  const data = {
      passengers,
      contact
    };
  return api.postFetch(`api/booking/passengers`, data)
}


function getAncillaries(request) {
  return api.getFetch(`api/booking/ancillaries`, request)
}

function getSeatMap() {
  return api.getFetch(`api/booking/Seats`)
} 

function addBaggage(flightId, passengerId, ssrCode) {
  const params = {
      logicalFlightId: flightId,
      passengerId,
      ssrCode,
    };

    return api.postFetch(`api/booking/addBaggage`, params)
}

function removeBaggage(flightId, passengerId, ssrCode) {
  const params = {
      logicalFlightId: flightId,
      passengerId: passengerId,
      ssrCode
    };

  return api.postFetch(`api/booking/removeBaggage`, params)
}

function addInsurance() {
  return api.postFetch(`api/booking/addInsurance`)
}

function removeInsurance() {
  return api.postFetch(`api/booking/removeInsurance`)
}

function addLounge(logicalFlightId, ssrCode) {
  const data = { logicalFlightId, ssrCode }

  return api.postFetch(`api/booking/addLounge`, data)
}

function removeLounge(logicalFlightId, ssrCode) {
  const data = { logicalFlightId, ssrCode }

  return api.postFetch(`api/booking/removeLounge`, data)
}

function addHotel(logicalFlightId, ssrCode) {
  const data = { logicalFlightId, ssrCode }

  return api.postFetch(`api/booking/addHotel`, data)
}

function removeHotel(logicalFlightId, ssrCode) {
  const data = { logicalFlightId, ssrCode }

  return api.postFetch(`api/booking/removeHotel`, data)
}

function addExpressBag(logicalFlightId) {
  const data = { logicalFlightId }

  return api.postFetch(`api/booking/addExpressBag`, data)
}

function removeExpressBag(logicalFlightId) {
  const data = { logicalFlightId }

  return api.postFetch(`api/booking/removeExpressBag`, data)
}

function addPriorityCheckin(logicalFlightId) {
  const data = { logicalFlightId }
  return api.postFetch(`api/booking/addPriorityCheckin`, data)
}

function removePriorityCheckin(logicalFlightId) {
  const data = { logicalFlightId }
  return api.postFetch(`api/booking/removePriorityCheckin`, data)
}

function addCarryOnBags(request) {
  return api.postFetch(`api/booking/addCarryOnBags`, request)
}

function removeCarryOnBags(request) {
  return api.postFetch(`api/booking/removeCarryOnBags`, request)
}

function addOversizedItems(request) {
  return api.postFetch(`api/booking/addOversizedItems`, request)
}

function removeOversizedItems(request) {
  return api.postFetch(`api/booking/removeOversizedItems`, request)
}

function addCounterCheckin(logicalFlightId) {
  return api.postFetch(`api/booking/addCounterCheckin`, { logicalFlightId })
}

function removeCounterCheckin(logicalFlightId) {
  return api.postFetch(`api/booking/removeCounterCheckin`, { logicalFlightId })
}

function addOnlineCheckin() {
  return api.postFetch('api/booking/addOnlineCheckin')
}

function removeOnlineCheckin() {
  return api.postFetch('api/booking/removeOnlineCheckin')
}

function addWhatsApp() {
  return api.postFetch(`api/booking/addWhatsApp`)
}

function removeWhatsApp() {
  return api.postFetch(`api/booking/removeWhatsApp`)
}

function changeMeals(selection) {
  if (!selection || !(selection.length > 0)) {
      return Promise.reject("Invalid data");
    }

  return api.postFetch(`api/booking/changeMeals`, selection)
}

function assignSeat(data) {
  return api.postFetch(`api/booking/assignSeat`, data)
}

function clearSeat(data) {
  return api.postFetch(`api/booking/clearSeat`, data)
}

function clearAllSeat() {
  return api.postFetch(`api/booking/clearAllSeat`)
}

function populateBooking() {
  return api.postFetch(`api/booking/populateBooking`)
}

function resetSegment(segmentIndex) {
  const data = {
      segmentIndex
    }

  return api.postFetch(`api/booking/resetSegment`, data)
}

function summaryPnr() {
  return api.postFetch(`api/booking/summaryPnr`)
}

function printItinerary() {
  return api.getFetch(`api/booking/printItinerary`)
}

function printItineraryWithoutPrice() {
  return api.getFetch(`api/booking/printItineraryWithoutPrice`)
}

function getPKPassFile() {
  return api.postFetch(`api/booking/pkPassFile`)
}

function feedback(data) {
  return api.postFetch(`api/booking/feedback`, data);
}

function ratePostDeparture(data) {
return api.postFetch(`api/booking/ratePostDeparture`, data);
}